export default __webpack_public_path__ + "static/color-picker-avoid-yellow-text-dont-9da1447e8c42c95f5a10297ceecc9f6c.png";